import { store } from "stores/Store";
import styles from './Details.module.scss';
import Select from "react-select";
import React, { useEffect, useRef, useState } from "react";
import { Tab } from "Modules/PractitionerBaseballCard";
import Text from "components/Text/Text";
import { observer } from "mobx-react";
import { ReactComponent as NotesIcon } from "assets/notes.svg";
import { Box, Button, Center, Group, ScrollArea, Stack, Title } from "@mantine/core";
import { Carousel } from "@mantine/carousel";
import "@mantine/carousel/styles.css";
import { closeDrawerModal, openDrawerModal } from "components/DrawerModal";
import { getStreetViewUrlFromAddress, getStreetViewUrlFromCoords, getStreetViewUrlsFromAddress, getStreetViewUrlsFromCoords } from "helpers/streetView";
import AddressForm from "Modules/PractitionerBaseballCard/components/AddressForm";
import GeoValidationDrawer from "components/GeoValidationDrawer";
import useExternalApiService from "helpers/ExternalApiService";
import { ReactComponent as PlusIcon } from "assets/plus.svg";
import TextWithLineBreaks from "components/TextWithBreaklines";

type GeoValidationAction = "validate" | "draft" | "";


// Helper: translate raw data_source → friendly text
const getDataSourceLabel = (ds?: string): string => {
  switch (ds) {
    case "PRACTITIONER_ACCOUNT_VIEW":
      return "From Netsuite";
    case "PRACTITIONER_ACCOUNT_VIEW_NM":
      return "From Badger Export";
    case "PRACTITIONER_DISTRIBUTOR_ACCOUNT_VIEW":
      return "Distributor";
    default:
      return ds || "Unknown"; // fallback if undefined or unrecognized
  }
};

const getChannelLabel = (ds?: string): string => {
  switch (ds) {
    case "PRACTITIONER_ACCOUNT_VIEW_NM":
      return "Not in Netsuite";
    default:
      return ds || ""; // fallback if undefined or unrecognized
  }
};

// Helper functions for conditional labels based on country
const getCityLabel = (country?: string): string => {
  return country === "AU" ? "Suburb" : "City";
};

const getStateLabel = (country?: string): string => {
  if (country === "CA") return "Province/State";
  if (country === "AU") return "State/Territory";
  return "State";
};

const getZipcodeLabel = (country?: string): string => {
  return country === "US" ? "Zipcode" : "Postal Code";
};



const handleContact = (opt: string, phone?: string) => {
  switch (opt) {
    case 'email':
      window.open(`mailto:${store.currentPractitioner?.email}`, '_blank');
      break;
    case 'phone':
      window.open(`tel:${phone}`, '_blank');
      break;

  }
}
interface IPractitionerDetails {
  navigate: (tab: Tab) => void;
}

const PractitionerDetails = observer(({ navigate }: IPractitionerDetails) => {
  const [distance, setDistance] = React.useState<number | null>(null);
  const [selectedAddress, setSelectedAddress] = useState<any>();
  const [streetViewPhotos, setStreetViewPhotos] = useState<string[]>([]);
  const [isLoadingStreetView, setIsLoadingStreetView] = useState<boolean>(false);
  const [isCarouselOpen, setIsCarouselOpen] = useState<boolean>(false);
  const apiUrl = process.env.REACT_APP_EAI_URL;
  const { patchData, putData, postData } = useExternalApiService(apiUrl);
  const isLead = ((store.currentPractitioner?.status === "LEAD-READY2SUBMIT") || (store.currentPractitioner?.status === "LEAD-INCOMPLETE"))
  const lat = selectedAddress?.latitude;
  const lon = selectedAddress?.longitude;

  React.useEffect(() => {
    
  }, []);

  useEffect(() => {
    if (store.currentPractitioner?.addresses && store.currentPractitioner?.addresses.length > 0) {
      // If we already have a selected address, update it with the new data
      if (selectedAddress?.id) {
        const updatedAddress = store.currentPractitioner.addresses.find(
          (a: any) => a.id === selectedAddress.id
        );
        if (updatedAddress) {
          setSelectedAddress(updatedAddress);
          return;
        }
      }
      // Otherwise, set the default address
      const defaultAddress = store.currentPractitioner.addresses.find(
        (a: any) => a.id === store.currentPractitioner.default_address
      );
      if (defaultAddress) {
        setSelectedAddress(defaultAddress);
      }
    }
  }, [store.currentPractitioner]);

  useEffect(() => {
    //address doesn't have lat or lon + have address or address1
    if (selectedAddress && (!selectedAddress?.latitude || !selectedAddress?.longitude) &&
      (selectedAddress?.address1 || selectedAddress?.address)) {
      handleGeoValidation();
    }

    if (selectedAddress) {
      calculteDistance()?.then((distance: number | null) => {
        if (distance !== null) {
          setDistance(distance);
        }
      });
    }
  }, [selectedAddress]);

  console.log("store.currentPractitioner=", store.currentPractitioner);
  const [geoValidationAction, setGeoValidationAction] = useState<GeoValidationAction>("");
  const handleGeoValidation = (action: GeoValidationAction = "validate") => {
    setGeoValidationAction(action);
  };

  const calculteDistance = () => {
    if (!selectedAddress?.latitude || !selectedAddress?.longitude) {
      return null;
    }

    // Get current position from browser
    if ("geolocation" in navigator) {
      console.log('hasnav');
      return new Promise<number>((resolve, reject) => {
        navigator.geolocation.getCurrentPosition((position) => {
          console.log("calculating", selectedAddress);
          const lat1 = position.coords.latitude;
          const lon1 = position.coords.longitude;
          const lat2 = selectedAddress?.latitude;
          const lon2 = selectedAddress?.longitude;

          const R = 6371; // Radius of earth in km
          const dLat = (lat2 - lat1) * Math.PI / 180;
          const dLon = (lon2 - lon1) * Math.PI / 180;
          const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
          const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
          const distance = R * c;

          resolve(Math.round(distance * 0.621371)); // Convert to miles and round
        }, (error) => {
          reject(error);
        });
      });
    }

    return null;
  }

  const handleStreetViewClick = async () => {
    if (!selectedAddress?.latitude || !selectedAddress?.longitude) {
      console.log('No coordinates available for street view');
      return;
    }
    console.log('clicked street view', selectedAddress);

    setIsLoadingStreetView(true);
    
    try {
      const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
      if (!apiKey) {
        console.error('Google Maps API key not configured');
        return;
      }
      let streetViewUrls;


      if (selectedAddress.address ) {
        streetViewUrls = await getStreetViewUrlsFromAddress(
          selectedAddress.address, 
          selectedAddress.latitude, 
          selectedAddress.longitude, 
          apiKey
        )
      }
      if (selectedAddress.latitude && selectedAddress.longitude && !streetViewUrls) {
      (streetViewUrls = await getStreetViewUrlsFromCoords(
        selectedAddress.latitude, 
        selectedAddress.longitude, 
        apiKey
      ))
      }
      if (streetViewUrls && streetViewUrls.length > 0) {
        setStreetViewPhotos(streetViewUrls);
      } else {
        console.log('Street View not available for this location');
      }
    } catch (error) {
      console.error('Error getting Street View:', error);
    } finally {
      setIsLoadingStreetView(false);
    }
  }
  

  return (
    <div className={styles.wrapper}>
      <GeoValidationDrawer
        opened={!!geoValidationAction}
        onClose={() => setGeoValidationAction("")}
        addressToValidate={
          selectedAddress?.address1 ? {
            administrativeArea: (selectedAddress?.state as any)?.value || "",
            locality: selectedAddress?.city || "",
            postalCode: selectedAddress?.zipcode || "",
            regionCode: selectedAddress?.country || "",
            addressLines: selectedAddress?.address1 ? [selectedAddress?.address1 || "", selectedAddress?.address2 || ""] : [selectedAddress?.address, ""],
          } : {
            administrativeArea: selectedAddress?.state  || "",
            locality: selectedAddress?.city || "",
            postalCode: selectedAddress?.zipcode || "",
            regionCode: selectedAddress?.country || "",
            addressLines: [selectedAddress?.address, ""],
          }
        }
        onConfirm={(a) => {
          if (a) {
            patchData(`/api/practitioner/${store.currentPractitioner?.id}/address/${selectedAddress.id}`, {
              address_data: {
                latitude: (a.latLon ? a.latLon[0] : undefined),
                longitude: (a.latLon ? a.latLon[1] : undefined),
              }
            }).then(() => {
              postData('/api/get_practitioner_by_id', {
                practitioner_id: store.currentPractitioner?.id,
              }).then((response) => {
                store.clearPractitionersCache();
                store.setCurrentPractitioner(response.practitioner);
              })

            });
          }
          setGeoValidationAction("");
        }}
      />
      {/*<div className={styles.sectionWrapper}>
        <p className={styles.headerText}>CONTACT INFORMATION</p>
      </div>*/}


      {!isLead ? (
        <Box>
          <Group justify="space-between" my="md">
            <Box c="dimmed">Default Check-in Address</Box>
            {store.currentPractitioner?.default_address !== selectedAddress?.id ? (
              <Button
                h={20}
                bg="#4F7D9C"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  putData(`/api/add_practitioner_to_chat/${store.currentPractitioner?.id}`, {
                    practitioner_data: {
                      default_address: selectedAddress?.id
                    }
                  });
                  store.clearPractitionersCache();
                  store.setCurrentPractitioner({
                    ...store.currentPractitioner,
                    default_address: selectedAddress?.id
                  });
                }}>
                SET
              </Button>
            ) : null }
          </Group>
          <Select
            value={selectedAddress}
            menuPlacement="auto"
            onChange={(v: any) => {
              if (v?.value) {
                const a = store.currentPractitioner.addresses.find((a: any) => a.id === v.value);
                if (a) {
                  setSelectedAddress(a);
                }
              }
            }}
            placeholder="Select an Address"
            components={{
              Control: (e) => {
                return (
                  <Group
                    style={{border: "1px solid #ddd", borderRadius: "10px"}}
                    align="center"
                    onClick={() => {
                      if (e.selectProps.menuIsOpen) {
                        e.selectProps.onMenuClose();
                      } else {
                        e.selectProps.onMenuOpen();
                      }
                    }}>
                    {e.children}
                  </Group>
                )
              },
              SingleValue: (e) => {
                const containerRef = useRef();

                const handleClickOutside = (event: any) => {
                  if (containerRef.current && !(containerRef.current as HTMLElement).contains(event.target)) {
                    e.selectOption(e.data);
                  }
                }

                useEffect(() => {
                  document.addEventListener('mousedown', handleClickOutside);
                  return () => {
                    document.removeEventListener('mousedown', handleClickOutside);
                  };
                }, []);

                console.log("selectedAddress", selectedAddress);
                return (
                  <Box
                    w="100%"
                    mt={0}
                    ref={containerRef as any}>
                    <Title order={5} w="100%" c="dark">
                      {selectedAddress?.is_visiting_address ? (
                        `VISITING ADDRESS ${e.options
                          .filter((oo) => store.currentPractitioner?.addresses?.find((a: any) => a.id === oo.value)?.is_visiting_address)
                          .findIndex((oo: any) => oo.value === selectedAddress.id) + 1}`
                      ) : selectedAddress?.data_source === "PRACTITIONER_ACCOUNT_VIEW" ? (
                        `SHIPPING/BILLING ADDRESS (OLD BACKUP)` 
                      ) :(
                        `SHIPPING/BILLING ADDRESS`
                      )}
                    </Title>
                  </Box>
                )
              },
              Input: (e) => {
                return <></>;
              },
              MenuList: (o) => {
                return (
                  <Box mah={300} style={{overflowY: "scroll"}} >
                    {o.children}
                  </Box>
                )
              },
              Option: (o) => {
                const address = store.currentPractitioner.addresses.find((a: any) => a.id === (o as any).value);
                if (!address) return <></>;

                return (
                  <Box
                    w="95%"
                    my={5}
                    style={{
                      borderBottom: "1px solid #eee",
                      padding: "10px",
                    }}
                    bg={(o as any)?.value === selectedAddress?.id ? "#E3F4FF" : "auto"}
                    onClick={() => o.selectOption(o.data)}>
                    <Title order={5} w="100%" c="dark" mb={2}>
                      {address?.is_visiting_address ? (
                        `VISITING ADDRESS ${o.options
                          .filter((oo) => store.currentPractitioner?.addresses?.find((a: any) => a.id === oo.value)?.is_visiting_address)
                          .findIndex((oo) => oo.value === (o as any).value) + 1}`
                      ) : (
                        `SHIPPING ADDRESS`
                      )}
                    </Title>
                    <Box pos="relative">
                      <Title order={6} fw="normal" c="gray">
                        {address.address}
                        <br />
                        {address.phone}
                      </Title>
                    </Box>
                  </Box>
                );
              }
            }}
            styles={{
              control: (baseStyles: any) => ({
                ...baseStyles,
                border: 'none',
                borderBottom: '1px solid #ccc',
                paddingLeft: 0,
                marginLeft: 0,
                color: '#4F7D9C',
                boxShadow: 'none',
                '&:hover': {
                  boxShadow: 'none'
                }
              }),
              valueContainer: (baseStyles: any) => ({
                ...baseStyles,
                paddingLeft: 0,
                marginLeft: 10,
                color: '#4F7D9C',
              }),
              indicatorSeparator: () => ({
                display: 'none'
              }),
              menu: (baseStyles: any) => ({
                ...baseStyles,
                zIndex: 999,
              }),
            }}
            options={store.currentPractitioner?.addresses
              ?.slice()
              ?.sort((a1: any, a2: any) => a1.id - a2.id)
              ?.map((a: any) => ({
              label: a.address,
              value: a.id
            }))}
          />

          <Group my="lg" grow px={10}>
            {selectedAddress?.is_visiting_address ? (
              <Button
                bg="#FF9D00"
                size="xs"
                leftSection={<NotesIcon width={15} style={{ stroke: "white" }} />}
                onClick={() => {
                  const modalId = openDrawerModal(
                    <AddressForm
                      practitionerId={store.currentPractitioner.id}
                      addressId={selectedAddress.id}
                      onSave={() => closeDrawerModal(modalId)}
                      initialForm={selectedAddress} />
                  )
                }}>
                Edit Address
              </Button>
            ) : null}
            <Button
              bg="#00DC49"
              size="xs"
              leftSection={<PlusIcon width={15} />}
              onClick={() => {
                const modalId = openDrawerModal(
                  <AddressForm
                    onSave={() => closeDrawerModal(modalId)}
                    practitionerId={store.currentPractitioner.id} />
                );
              }}>
              Add Address
            </Button>
          </Group>
        </Box>
      ) : null}


      <div className={styles.twoColumnWrapper}>
        <div>
          <Text type="primary" bold>Phone</Text>
          {selectedAddress?.phone ? (
            <Text onClick={() => handleContact("phone",selectedAddress?.phone)}>{selectedAddress?.phone}</Text>
          ) : (
            <div className={styles.missingValue}>Missing</div>
          )}
        </div>
        <div>
          <Text type="primary" bold>Is Residential?</Text>
          <Text>{selectedAddress?.is_residential ? "Yes" : "No"}</Text>
        </div>
        <div>
          <Text type="primary" bold>Street Address</Text>
          {selectedAddress?.address ? (
            <>
              <Text>{selectedAddress?.address1}</Text>
              {selectedAddress?.address2 && (<Text>{selectedAddress?.address2}</Text>)}
            </>
          ) : (
            <div className={styles.missingValue}>MISSING</div>
          )}
        </div>
        <div>
          <Text type="primary" bold>Full Address</Text>
          {/*<Text type="primary">(For Error Checking: Will Remove in Future)</Text>*/}
          {(selectedAddress?.address) ? (
            <TextWithLineBreaks text={`${selectedAddress?.address} `} />
          ) : (
            <div className={styles.missingValue}>MISSING</div>
        )}
        
        </div>

      </div>


      <div className={styles.twoColumnWrapper}>
        {selectedAddress?.city? (
          <div>
            <Text type="primary" bold>{getCityLabel(selectedAddress?.country)}</Text>
            {(selectedAddress?.city) ? (
              <Text>{`${selectedAddress?.city}`}</Text>
            ) : (
              <div className={styles.missingValue}>MISSING</div>
            )}
          </div>
        ) : null}
 
        <div>
          <Text type="primary" bold>{getStateLabel(selectedAddress?.country)}</Text>
          {(selectedAddress?.city && selectedAddress?.state) ? (
            <Text>{`${selectedAddress?.state}`}</Text>
          ) : (
            <div className={styles.missingValue}>MISSING</div>
          )}          
        </div>


      </div>
      <div className={styles.twoColumnWrapper}>
        <div>
          <Text type="primary" bold>{getZipcodeLabel(selectedAddress?.country)}</Text>
          {(selectedAddress?.zipcode) ? (
            <Text>{selectedAddress?.zipcode}</Text>
          ) : (
            <div className={styles.missingValue}>MISSING</div>
          )}
          {/*<Text>{`${store.currentPractitioner?.city}, ${store.currentPractitioner?.state}`}</Text>*/}
        </div>
        <div>
          <Text type="primary" bold>Country</Text>
          {selectedAddress?.country ? (
            <Text>{selectedAddress?.country}</Text>
          ) : (
            <div className={styles.missingValue}>MISSING</div>
          )}
        </div>
        <div>
          <Text type="primary" bold>Distance</Text>
          {/*<Text>{distance ? `${distance} miles away` : 'Calculating...'}</Text>*/}
          {lat == null || lon == null
            ? (<Text>Cannot Calculate: Missing Lat/Long.</Text>)
            : distance == null
              ? (<Text>Cannot calculate: did you allow app to use GPS?</Text>)
              : (<Text>{`${distance} miles away`}</Text>)}
        </div>
        <div>
          <Text type="primary" bold>Lat & Long</Text>
          {(lat && lon) ? (
            <div
              onClick={() => {
                console.log('Clicked lat/lon. isLead:', isLead, 'is_visiting:', selectedAddress.is_visiting_address);
                if(isLead) {
                  console.log('Cannot edit - this is a lead');
                  return;
                }
                console.log('Triggering geo validation');
                handleGeoValidation();
              }}
              style={{
                cursor: isLead ? 'default' : 'pointer',
                position: 'relative',
                display: 'inline-block',
                maxWidth: 'fit-content'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Text>{lat}</Text>
                  <Text>{lon}</Text>
                </div>
                {!isLead && (
                  <NotesIcon style={{
                    color: "#4F7D9C",
                    stroke: "#4F7D9C",
                    width: "16px",
                    height: "16px",
                    flexShrink: 0
                  }} />
                )}
              </div>
            </div>
          ) : (
            <div
              onClick={() => {
                if(isLead) return;
                handleGeoValidation();
              }}
              className={isLead ? styles.missingValueLatLead : styles.missingValueLat}
            ><div>MISSING</div>
              {!isLead ? (<NotesIcon style={{ color: "white", stroke: "white" }} />) : null}
              </div>
          )}
          {/*<Text>{`${store.currentPractitioner?.latitude}, ${store.currentPractitioner?.longitude}`}</Text>*/}
        </div>
      </div>
      
      <div className={styles.streetViewSection}>
        <div 
          className={styles.streetViewBackground}
          style={{
            background: streetViewPhotos.length > 0 
              ? `url(${streetViewPhotos[0]})`
              : undefined,
            backgroundPosition: streetViewPhotos.length > 0 
              ? 'center 50%'
              : undefined
          }}
          onClick={streetViewPhotos.length > 0 ? () => setIsCarouselOpen(true) : undefined}
        >
          {streetViewPhotos.length === 0 && (
            <button 
              className={styles.streetViewButton}
              onClick={handleStreetViewClick}
              disabled={isLoadingStreetView || !selectedAddress?.latitude || !selectedAddress?.longitude}
            >
              {isLoadingStreetView ? 'LOADING...' : 'SHOW STREET VIEW'}
            </button>
          )}
        </div>
      </div>

      {isCarouselOpen && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onClick={() => setIsCarouselOpen(false)}
        >
          <div 
            style={{
              width: '90%',
              maxWidth: '800px',
              position: 'relative'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setIsCarouselOpen(false)}
              style={{
                position: 'absolute',
                top: '-40px',
                right: '0',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                zIndex: 1001,
                fontSize: '24px',
                fontWeight: 'bold',
                color: 'white'
              }}
            >
              ×
            </button>
            <Carousel
              height={400}
              slideSize="100%"
              slideGap="md"
              withIndicators
              withControls
              styles={{
                control: {
                  '&[data-inactive]': {
                    opacity: 0,
                    cursor: 'default',
                  },
                },
                indicator: {
                  width: '12px',
                  height: '12px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(255, 255, 255)',
                  '&[data-active]': {
                    backgroundColor: 'white',
                  },
                },
              }}
            >
              {streetViewPhotos.map((photo, index) => (
                <Carousel.Slide key={index}>
                  <div 
                    style={{
                      background: `url(${photo})`,
                      backgroundPosition: 'center',
                      backgroundSize: 'cover',
                      height: '400px',
                      borderRadius: '8px'
                    }}
                  />
                </Carousel.Slide>
              ))}
            </Carousel>
          </div>
        </div>
      )}
      <div className={styles.sectionWrapper}>
        <p className={styles.headerText}>ACCOUNT DETAILS</p>
      </div>

      <div className={styles.twoColumnWrapper}>
        <div>
          <Text type="primary" bold>Company Name</Text>
          {/*<Text>{store.currentPractitioner?.email}</Text>*/}
          {store.currentPractitioner?.companyname ? (
            <Text>{store.currentPractitioner?.companyname}</Text>          
          ) : (
            <div className={styles.missingValue}>Missing</div>
          )}
        </div>
        <div>
          <Text type="primary" bold>Email</Text>
          {/*<Text>{store.currentPractitioner?.email}</Text>*/}
          {store.currentPractitioner?.email ? (
            <Text onClick={() => handleContact('email')}>{store.currentPractitioner?.email}</Text>
          ) : (
            <div className={styles.missingValue}>Missing</div>
          )}
        </div>
        <div>
          <Text type="primary" bold>Account Owner</Text>
          <Text>{store.currentPractitioner?.fmc}</Text>
        </div>

        <div>
          <Text type="primary" bold>Ready to Purchase</Text>
          <Text>{store.currentPractitioner?.ready_to_purchase ? "Yes" : "No"}</Text>
        </div>
        {/* <div>
          <Text type="primary" bold>Stage</Text>
          {store.currentPractitioner?.stage ? (
            <Text>{store.currentPractitioner?.stage}</Text>
          ) : (
            <div className={styles.missingValue}>Missing</div>
          )}
        </div> */}
        <div>
          <Text type="primary" bold>Status</Text>
          {store.currentPractitioner?.status ? (
            ['LEAD-INCOMPLETE', 'LEAD-READY2SUBMIT', 'LEAD-AWAITING-NETSUITE'].includes(store.currentPractitioner.status) ? (
              <Text>{store.currentPractitioner.status}</Text>
            ) : (
              store.currentPractitioner?.stage ? (
                <Text>{`${store.currentPractitioner.stage}-${store.currentPractitioner.status}`}</Text>
              ) : (
                <div className={styles.missingValue}>Missing</div>
              )
            )
          ) : (
            <div className={styles.missingValue}>Missing</div>
          )}
        </div>
        <div>
          <Text type="primary" bold>Specialty</Text>
          {store.currentPractitioner?.specialty ? (
            <Text>{store.currentPractitioner?.specialty}</Text>
          ) : (
            <div className={styles.missingValue}>Missing</div>
          )}
        </div>
        <div>
          <Text type="primary" bold>Practice Type</Text>
          {store.currentPractitioner?.practice_type ? (
            <Text>{store.currentPractitioner.practice_type}</Text>
          ) : (
            <div className={styles.missingValue}>Missing</div>
          )}
        </div>
        <div>
          <Text type="primary" bold>Website</Text>
          {store.currentPractitioner?.website ? (
            <Text onClick={() => {
              const website = store.currentPractitioner?.website;
              const url = website?.startsWith('http://') || website?.startsWith('https://') 
                ? website 
                : `https://${website}`;
              window.open(url, '_blank');
            }}>{store.currentPractitioner?.website}</Text>
          ) : (            
            <div className={styles.missingValue}>Missing</div>
          )}
        </div>
      </div>
      <div className={styles.sectionWrapper}>
        <p className={styles.headerText}>Data Source</p>
      </div>
      <div className={styles.twoColumnWrapper}>
        <div>
          <Text type="primary" bold>Data Source</Text>
          {/*<Text>{getDataSourceLabel(store.currentPractitioner?.data_source)}</Text>*/}
          <Text>
            {(
              store.currentPractitioner?.status === "LEAD-INCOMPLETE" ||
              store.currentPractitioner?.status === "LEAD-READY2SUBMIT"
            )
              ? "Lead created with Sales Assistant"
              : getDataSourceLabel(store.currentPractitioner?.data_source)
            }
          </Text>
        </div>
        <div>
          <Text type="primary" bold> </Text>
          {/*<Text>{store.currentPractitioner?.name_dfh_channel}</Text>*/}
          <Text>{getChannelLabel(store.currentPractitioner?.name_dfh_channel)}</Text>
        </div>
      </div>
      <div className={styles.twoColumnWrapper}>
        <div>
          <Text type="primary" bold>NETSUITE ID</Text>
          {/*<Text>{getDataSourceLabel(store.currentPractitioner?.data_source)}</Text>*/}
          {(store?.currentPractitioner?.netsuite_id) ? (
            <Text>{store?.currentPractitioner?.netsuite_id}</Text>
          ) : (
            <div className={styles.missingValue}>MISSING</div>
          )}
        </div>
      </div>
    </div>
  )
})

export default PractitionerDetails;